import { AcquisitionForm, ActionCard, Heading, P } from '@pcln/horizon'
import type { AcquisitionFormData } from '@pcln/horizon'

import useBootstrapData from '@/hooks/useBootstrapData'
import useHandleAppDownloadSubmit from '@/hooks/useHandleAppDownloadSubmit'

import { CONTENT, trackHelpCenter, trackMyTrips } from './utils'

type SubmitHandler = (values: { phoneNumber: string }) => Promise<void>

export default function AppDownloadOptIn() {
  const [handleSubmitNumber, signUpState] = useHandleAppDownloadSubmit() as [SubmitHandler, string]
  const { signInStatus } = useBootstrapData()

  const onSubmit = async ({ phoneNumber }: AcquisitionFormData) => {
    if (phoneNumber) {
      await handleSubmitNumber({ phoneNumber })
    }
  }

  return (
    <div className='flex gap-4'>
      <div className='min-w-0 flex-[13] rounded-2xl p-4 shadow-sm'>
        <AcquisitionForm
          type='appDownload'
          onSubmit={onSubmit}
          phonePlaceholder={CONTENT.placeholderText}
          buttonText={CONTENT.buttonText}
          qrCodePosition='right'
          qrCodeText='Or scan our QR code'
          isLoading={signUpState === 'SIGN_UP_IN_PROGRESS'}
          successMessage={signUpState === 'SIGNED_UP' ? CONTENT.successMessage : undefined}
          errorMessage={signUpState === 'SIGN_UP_ERROR' ? CONTENT.failureMessage : undefined}
          childrenSlot={
            <div className='flex flex-col gap-1'>
              <Heading textStyle='heading4'>{CONTENT.heading}</Heading>
              <P textStyle='body2'>{CONTENT.subheading}</P>
            </div>
          }
        />
      </div>
      <div className='flex min-w-0 flex-[7] flex-col justify-center gap-4'>
        <ActionCard
          role='button'
          mediaType='icon'
          mediaContent='luggage'
          heading='My Trips'
          body='Quickly find your booking reservations and redeem flight credits'
          onClick={() => trackMyTrips(signInStatus.signedIn)}
        />
        <ActionCard
          role='button'
          mediaType='icon'
          mediaContent='help'
          heading='Help Center'
          body='We are always here for you - reach us 24hrs a day, 7 days a week'
          onClick={trackHelpCenter}
        />
      </div>
    </div>
  )
}
